// removed by extract-text-webpack-plugin
module.exports = {"component":"bmbo_component_1_Krc","preview":"bmbo_preview_vVc6O","preview-item":"bmbo_preview-item_24hps","information":"bmbo_information_3ddeo"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/index.scss
// module id = 94
// module chunks = 0